module.exports = __webpack_public_path__ + "img/chevron-down.3b5b0cda.svg";